import { render } from "./ProjectsPane.vue?vue&type=template&id=512db64d&scoped=true"
import script from "./ProjectsPane.vue?vue&type=script&lang=js"
export * from "./ProjectsPane.vue?vue&type=script&lang=js"

import "./ProjectsPane.vue?vue&type=style&index=0&id=512db64d&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512db64d"]])

export default __exports__